import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as Actions from "actions/seller/seller.store";

import {Box, Container} from "@mui/material";
import {useEffect} from "react";

import VideoUpload from "components/VideoUpload";
import VideoPlayer from "components/VideoPlayer";


const AdminShopCollectionVideoEditor = (props) => {

  const { serviceError, reqStatus, isLoading,
      adminAddShopCollectionVideoClicked, collections, shop_id,
      cancelEdit } = props;

    //const { logo } = selectedShop;

    useEffect(() => {
    if (serviceError && reqStatus) {
      const feedback = {
        title: "Something went wrong!",
        description: serviceError.statusText,
      };
      sendNotification("error", feedback);
    }
  }, [serviceError, reqStatus]);

  const sendNotification = (type, { title, description = "" }) => {
    console.log({
      message: title,
      description,
    });
  };

    const addVideoCallback = (file) => {

        const formData = new FormData();
        formData.append('inputFile', file);
        adminAddShopCollectionVideoClicked(shop_id, formData);
    }


    return (
        <Container>
            <Box >
                <VideoUpload isRemoveAllowed={false}
                             addVideoCallback={addVideoCallback}
                             cancelEdit={cancelEdit}
                             idx="3"
                />
                {collections && collections.map((video, index) => (
                <VideoPlayer
                    id={"demo-player" + index}
                    publicId={video && video.cdn.secure_url}
                    width="360"
                    height="480"
                />
            ))}
            </Box>
        </Container>
    );
};

export default AdminShopCollectionVideoEditor;
